import { AxiosResponse } from 'axios';
import { SET_PAYROLL_PERIODS, SET_PAYROLL_PERIOD, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PAYROLL_PERIOD_ISLOADING,
  DELETE_PAYROLL_PERIOD,
  EDIT_PAYROLL_PERIOD,
  GET_PAYROLL_PERIODS,
  GET_PAYROLL_PERIOD,
  REGISTER_PAYROLL_PERIOD,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import PayrollPeriod from '@/services/payroll_period';
import { Module } from 'vuex';
import { EditPayrollPeriod, RegisterPayrollPeriod, GetPayrollPeriod } from '@/dtos/payroll_period.dto';

const payrollPeriod: Module<any, {}> = {
  state: {
    payrollPeriod: {
      data: null,
      isLoading: false,
    },
    payrollPeriods: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    payrollPeriod: (state: { payrollPeriod: any }) => state.payrollPeriod,
    payrollPeriods: (state: { payrollPeriods: any }) => state.payrollPeriods,
  },
  mutations: {
    [SET_PAYROLL_PERIOD]: (
      state: { payrollPeriod: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      (state.payrollPeriod.data = payload.data),
        (state.payrollPeriod.isLoading = payload.isLoading);
    },
    [SET_PAYROLL_PERIODS]: (
      state: { payrollPeriods: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.payrollPeriods.data = payload.data) : null,
        (state.payrollPeriods.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PAYROLL_PERIOD]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_PERIOD, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollPeriod.registerPayrollPeriod(
        payload as RegisterPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_PERIOD, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_PERIOD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_PERIOD, { isLoading: false });
        return false;
      }
    },
    [GET_PAYROLL_PERIODS]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_PERIODS, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollPeriod.getPayrollPeriods(
        payload as GetPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_PERIODS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_PERIODS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_PERIODS, { isLoading: false });
        return false;
      }
    },
    [GET_PAYROLL_PERIOD]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_PERIOD, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollPeriod.getPayrollPeriods(
        payload as GetPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_PERIOD, { data: result.data.data[0] ?? null, isLoading: false });
          return result.data.data[0];
        }
        commit(SET_PAYROLL_PERIOD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_PERIOD, { isLoading: false });
        return false;
      }
    },
    [EDIT_PAYROLL_PERIOD]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_PERIOD, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollPeriod.editPayrollPeriod(
        payload as EditPayrollPeriod
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL_PERIOD, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_PERIOD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_PERIOD, { isLoading: false });
        return false;
      }
    },
    [DELETE_PAYROLL_PERIOD]: async ({ commit }: any, payload: string) => {
      commit(SET_PAYROLL_PERIOD, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollPeriod.deletePayrollPeriod(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL_PERIOD, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_PERIOD, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_PERIOD, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PAYROLL_PERIOD_ISLOADING]: ({ commit }) => {
      commit(SET_PAYROLL_PERIOD, { isLoading: false });
      commit(SET_PAYROLL_PERIODS, { isLoading: false });
    },
  },
};

export default payrollPeriod;
